import Icon from '../../../commonComponent/icon/Icon';
import {t, useSiteLanguage} from "../../../i18n";
import restaurantInfo from "../../../data/restaurant.json";
import openningHours from "../../../data/hours.json";
import {ListeHoraires, StatutOuverture} from "./HoraireContactService";
import ReservationButton from "../../../commonComponent/reservation/ReservationButton";
import SocialLinks from "../../../commonComponent/socialLinks/SocialLinks";
import SectionPanel from "../../../commonComponent/section/SectionPanel";

/**
 * Horaires et contact, les deux panneaux qui répondent à « quand » et « où ».
 *
 * ## Ce que le panneau des horaires portait, et ce qu'il lui manquait
 *
 * Un titre et deux lignes, dans une boîte de 380 px de haut. Le vide ne venait pas d'un manque
 * de décor mais d'un manque de réponse : celui qui lit des horaires veut savoir si c'est ouvert
 * **maintenant**, et il devait le calculer lui-même.
 *
 * L'état courant et la mise en avant du jour se déduisent entièrement du fichier existant.
 * Le bouton de réservation ferme la séquence : c'est le geste qui suit la lecture d'un horaire.
 */
const HoraireContact = () => {
    useSiteLanguage();

    return (
        <section className="content-row contact-row">
            <SectionPanel variant="secondary" className="hours-panel" title={t("hours.title")}>

                <StatutOuverture horaires={openningHours.openingHours} />
                <ListeHoraires horaires={openningHours.openingHours} />

                <ReservationButton className="hours-cta" />
            </SectionPanel>

            <SectionPanel id="horaires" className="contact-panel" title={t("nav.contact")}>

                <address className="contact-details">
                    <a href={restaurantInfo.googleMapsUrl} rel="noreferrer" target="_blank"
                       className="contact-address">{restaurantInfo.adresse}</a>

                    <a rel="noreferrer" target="_blank" href={restaurantInfo.googleMapsUrl}
                       className="contact-line">
                        <Icon name="geo-alt"/> Google Maps
                    </a>

                    <span className="phone-links">
                        <a href={`tel:${restaurantInfo.fixNumber}`} className="contact-line">
                            <Icon name="telephone-fill"/> {restaurantInfo.fixNumber}
                        </a>
                        <a href={`tel:${restaurantInfo.telNumber}`} className="contact-line">
                            <Icon name="telephone-fill"/> {restaurantInfo.telNumber}
                        </a>
                    </span>
                </address>

                <SocialLinks networks={restaurantInfo.socialNetworks} />
            </SectionPanel>
        </section>
    );
};

export default HoraireContact;
